import React, { useState, useMemo } from "react";
import DataTable from "components/DataTable";
import PageWrapper from "components/PageWrapper";
import { useTableData } from "../../hooks/useTableData";
import { bcWalletReportConfig } from "config/tableConfigs";
import { useSession } from "hooks/useSession";

const BCWalletReportPage = () => {
  const { userid, role } = useSession();
  const userRole = role === "Platform User" ? "Admin" : role;
  const [loading] = useState(false);

  const apiUrl = `https://pro.mokshiq.in/get_bcwallet_report?user=${userid}`;

  const tableData = useTableData(apiUrl, 0, bcWalletReportConfig);

  const filteredConfig = useMemo(() => {
    const base = {
      ...bcWalletReportConfig,
      columns: [...bcWalletReportConfig.columns],
    };

    const roleMap = {
      Admin: [
        "BC_ID",
        "Admin  Name",
        "Mobile",
        "Role",
        "Wallet Balance",
        "Instant Pay Onboarding",
        "Eko Onboarding",
        "Iserveu Onboarding",
      ],

      "Main Admin": [
        "BC_ID",
        "Admin Name",
        "Mobile",
        "Role",
        "Wallet Balance",
      ],

      Distributer: [
        "id",
        "ref_no",
        "ack_no",
        "transection_type",
        "product",
        "number",
        "amount",
        "status",
        "commission",
        "tds",
        "bank_rrn",
        "aadhar_number",
      ],

      "Super Distributer": [
        "id",
        "ref_no",
        "ack_no",
        "transection_type",
        "product",
        "number",
        "amount",
        "status",
        "commission",
        "tds",
        "bank_rrn",
        "aadhar_number",
      ],
    };

    const allowedKeys = roleMap[userRole] || [];
    base.columns = base.columns.filter((c) =>
      allowedKeys.includes(c.key)
    );

    return base;
  }, [userRole]);

  return (
    <div>
      {loading && (
        <div className="page-loader-overlay d-flex justify-content-center align-items-center">
          <div className="spinner-border text-primary" />
        </div>
      )}

      <PageWrapper config={bcWalletReportConfig}>
        {/* 🔥 Show Total Wallet for Main Admin */}
        {role === "Main Admin" && tableData?.total_amount && (
          <div className="mb-3">
            <div className="card shadow-sm p-3">
              <h6 className="mb-1">Total Wallet Balance</h6>
              <h4 className="text-primary">
                ₹ {Number(tableData.total_amount).toFixed(2)}
              </h4>
            </div>
          </div>
        )}

        <DataTable
          config={filteredConfig}
          tableData={tableData}
        />
      </PageWrapper>
    </div>
  );
};

export default BCWalletReportPage;
